import { z } from 'zod';

export const stringLimited = (limit: number) =>
  z.string().max(limit, `You've reached the character limit: ${limit}`);
